import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Truck } from "lucide-react";

/**
 * Pre-order shipping notice. Pulls the launch date from /api/shop-status.
 * Auto-hides once the shop is past the launch window (no manual cleanup needed).
 */
const PreorderShippingNotice = () => {
    const [status, setStatus] = useState(null);

    useEffect(() => {
        let alive = true;
        api.get("/shop-status")
            .then((r) => {
                if (alive) setStatus(r.data);
            })
            .catch(() => {
                /* silently skip — non-critical */
            });
        return () => {
            alive = false;
        };
    }, []);

    if (!status || status.phase !== "preorder") return null;

    const launchDate = status.launch_date
        ? new Date(status.launch_date).toLocaleDateString("en-US", {
              month: "long",
              day: "numeric",
              year: "numeric",
          })
        : "July 1, 2026";

    return (
        <div
            data-testid="preorder-shipping-notice"
            className="flex items-start gap-3 p-4 mb-5 border-l-2 border-l-[#eab308] bg-[#eab308]/5"
        >
            <Truck className="w-5 h-5 text-[#eab308] flex-shrink-0 mt-0.5" />
            <div>
                <div className="font-chivo text-[10px] tracking-[0.22em] uppercase text-[#eab308] mb-1">
                    Pre-order
                </div>
                <p className="font-body text-sm text-slate-200 leading-snug">
                    Pre-orders will ship on{" "}
                    <span className="font-semibold text-white">{launchDate}</span>.
                </p>
            </div>
        </div>
    );
};

export default PreorderShippingNotice;
